















































import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { APP_URL } from "@/common/http";
import { createDate } from "@/common/utils";
import { IUploadFile } from "@/components/shared/types";
import UploadUI from "@/components/shared/UploadFileUI.vue";

@Component({
  components: {
    'file-upload': UploadUI
  }
})
export default class ImageUploader extends Vue {
  @Prop({
    default: null
  }) data: Object; //User

  appUrl:string = APP_URL;
  imageArchive: any[] = [];
  SelectedImageCategory:any = {}; // must initialize as {}

  get User() : User {
    return this.$store.getters.User;
  };

  get language() : string {
    return this.User.Language;
  };

  created() {
    if (this.data) {
      this.SelectedImageCategory = this.data['category'];
    }
  }

  imageFiles:IUploadFile[] = [];
  uploadImageFiles:boolean = false;
  uploadMapFiles:boolean = false;

  doUploadFile() {
      this.uploadImageFiles = true;
      (<any>this.$refs['imageUpload']).startUpload();
    };

  cancelUploadFile() {
    this.uploadImageFiles = false;
  };

  addImageFiles(event) {
    let files:IUploadFile[] = event.files;
    files.forEach((file) => {
      this.imageFiles.push(file);
    });
  };

  removeImageFile(event) {
    let file:IUploadFile = event.file;
    this.imageFiles.forEach((f,i) => {
      if (f==file)
      this.imageFiles.splice(i,1);
    });
    this.imageFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };

  goBack() {
    if (this.data['hasImage']) {
      this.$emit('changeMe',{
        menu: {
          name: 'image_archive',
        },
        data: this.SelectedImageCategory
      });
    } else {
      this.$emit('changeMe',{
        menu: {
          name: 'image_category',
        }
      });
    }
  }
  
  closeMe() {
    this.$emit('closeRightToc');
  }
}
